"use strict";
/**
 * Dictation domain models
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DICTATION_SETTINGS = void 0;
/**
 * Default dictation settings
 */
exports.DEFAULT_DICTATION_SETTINGS = {
    pauseBetweenWords: 1000,
    pauseBetweenSentences: 2000,
    playbackSpeed: 1.0,
    autoRepeat: false,
    timeoutPerSentence: 30000,
};
//# sourceMappingURL=dictation.js.map